import { z } from 'zod';

export const InstrumentSchema: z.ZodSchema = z.lazy(() =>
  z.object({
    instrumentName: z.string().max(100),

    // L'icona ora è un oggetto con nome e URL, invece di una stringa URL
    icon: z
      .object({
        name: z.string().max(255),
        caption: z.string().nullable().optional(),
        url: z.string().url().nullable(),
      })
      .nullable()
      .optional(),

    instrumentCategory: z
      .object({
        id: z.string().uuid().optional(),
        instrumentCategoryName: z.string().max(100),
      })
      .nullable()
      .optional(),

    parentInstrument: z
      .lazy(() => InstrumentSchema)
      .nullable()
      .optional(),
  }),
);

export type Instrument = z.infer<typeof InstrumentSchema>;

export const GetInstrumentsResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
  instruments: z.array(InstrumentSchema), // 👈 Si aspetta un oggetto con `instruments`
  error: z.string().optional(),
});

export type GetInstrumentsResponse = z.infer<typeof GetInstrumentsResponseSchema>;

export const studySessionsSchema = z.array(z.object({ description: z.string() }));

export type StudySessions = z.infer<typeof studySessionsSchema>;

export const studySessionsOption = z.object({
  name: z.string(),
  imageSrc: z.string(),
  altText: z.string(),
  feedback: z.object({
    text: z.string(),
    imageSrc: z.string(),
  }),
});

export type StudySessionsOption = z.infer<typeof studySessionsOption>;

export const studySessionsOptions = z.array(studySessionsOption);

export type StudySessionsOptions = z.infer<typeof studySessionsOptions>;

export const skillLevelOptionSchema = z.object({
  name: z.string(),
  onboardingDescription: z.string(),
  onboardingDescriptionAdditional: z.string(),
});

export type SkillLevelOptionSchema = z.infer<typeof skillLevelOptionSchema>;

export const skillLevelsArraySchema = z.array(skillLevelOptionSchema);

export type SkillLevelsArraySchema = z.infer<typeof skillLevelsArraySchema>;

export const skillLevelSchema = z.object({
  name: z.string(),
});

export type SkillLevelSchema = z.infer<typeof skillLevelSchema>;

export const profileSkillLevelsSchema = z.object({
  skillLevel: skillLevelSchema,
});

export type ProfileSkillLevelsSchema = z.infer<typeof profileSkillLevelsSchema>;

export const profileSkillLevelsArraySchema = z.array(profileSkillLevelsSchema);

export type ProfileSkillLevelsArraySchema = z.infer<typeof profileSkillLevelsArraySchema>;

export const profileSkillLevelSchema = z.object({
  skillLevel: z.string(),
});

export type ProfileSkillLevelSchema = z.infer<typeof profileSkillLevelSchema>;

export const profileSkillLevelResponse = z.object({
  message: z.string(),
});

export type ProfileSkillLevelResponse = z.infer<typeof profileSkillLevelResponse>;

export const createProfilePayload = z.object({
  instrumentName: z.string(),
  studySession: z.string(),
  skillLevel: z.string(),
});

export type CreateProfilePayload = z.infer<typeof createProfilePayload>;

export const createProfileResponse = z.object({
  message: z.string(),
});

export type CreateProfileResponse = z.infer<typeof createProfileResponse>;
